import { PageProps } from 'gatsby';
import React, { useEffect } from 'react';
// import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
// import { SubmitHandler, useForm } from 'react-hook-form';

// import { LoadingButton } from '@mui/lab';
import { Alert, Box, Container, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2'; // Grid version 2
// import { useSeekaConverge } from '@seeka-labs/converge-react';
import { AnalyticsPageType } from '@shopify/hydrogen-react';

import SeoHead from '../components/head';
import { HorizontalSlantContainer } from '../components/horizontal-slant-container';
import { useAnalytics } from '../shared/analytics';
// import { ContactFormInput } from '../shared/models/contactFormInput';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import { headerSlantContainerNoContent } from '../shared/styles/headerSlantContainer';
import { FaqList } from '../templates/faq/faqList';

// const recapchaSiteKey = process.env.GATSBY_GOOGLE_RECAPTCHA_V3_SITEKEY as string;

// const encode = (data) => {
//     return Object.keys(data)
//         .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
//         .join("&");
// }

// const ContactForm = () => {
//     const { register, handleSubmit, reset, formState: { errors, isValid } } = useForm<ContactFormInput>({
//         mode: 'all',
//         reValidateMode: 'onBlur',
//         defaultValues: {
//             name: '',
//             email: '',
//             message: '',
//             orderNumber: ''
//         }
//     });
//     const [submitting, setSubmitting] = useState(false);
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState(false);
//     // const { executeRecaptcha } = useGoogleReCaptcha()
//     const converge = useSeekaConverge();

//     const onSubmit: SubmitHandler<ContactFormInput> = async data => {
//         setSubmitting(true)
//         setError('')
//         setSuccess(false)
//         // Check if the captcha was skipped or not
//         // if (!executeRecaptcha) {
//         //     return
//         // }
//         // event.preventDefault();

//         // const myForm = event.target;
//         // const formData = new FormData(myForm);

//         const onError = (errors?: any) => {
//             console.log('Failed to send message', errors)
//             setError('Failed to send message. Please try again later.')
//         }

//         try {
//             const response = await fetch("/", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/x-www-form-urlencoded" },
//                 body: encode({
//                     email: data.email,
//                     message: data.message,
//                     name: data.name,
//                     orderNumber: data.orderNumber,
//                     "bot-field": (document.getElementById('botField') as any)?.value,
//                     "form-name": "contact"
//                 })
//             })

//             // const recaptchaToken = await executeRecaptcha('contact')
//             // const response = await fetch("/api/contact", {
//             //     method: "POST",
//             //     headers: { "Content-Type": "application/json" },
//             //     body: JSON.stringify({
//             //         recaptchaToken,
//             //         ...data
//             //     })
//             // })
//             // console.log('heree contact resp', response)
//             if (response.ok) {
//                 setSuccess(true)
//                 reset();

//                 const nameSeparated = converge.util.text.separatePersonFullName(data.name);
//                 converge.identity.mergeProfile({
//                     email: [data.email],
//                     firstName: nameSeparated.firstName ? [nameSeparated.firstName] : [],
//                     lastName: nameSeparated.lastName ? [nameSeparated.lastName] : []
//                 })
//                     .finally(() => {
//                         converge.track.contactMessage()
//                     })
//             }
//             else {
//                 onError()
//             }
//         }
//         catch (err) {
//             onError(err)
//         }
//         finally {
//             setSubmitting(false)
//         }
//     };

//     return (
//         <form
//             noValidate
//             onSubmit={handleSubmit(onSubmit)}
//             method="post"
//             name="contact"
//             data-netlify="true"
//             // data-netlify="true"
//             autoComplete="off"
//             data-netlify-honeypot="bot-field"
//         // netlify-honeypot="bot-field"
//         // data-netlify-recaptcha="true"
//         >
//             {/* <input type="hidden" name="form-name" value="contact" /> */}
//             <p style={{ display: "none" }}>
//                 <label>
//                     Dont fill this out: <input name="bot-field" id="botField" />
//                 </label>
//             </p>

//             <Stack spacing={2} direction='column'>
//                 <div style={{ display: 'none' }}><TextField {...register("honeyPot", { required: false })} /></div>
//                 <TextField {...register("name", { required: true })} label="Name" variant="outlined" error={Boolean(errors.name)} helperText={errors.name?.message} />
//                 <TextField {...register("email", {
//                     required: true, pattern: {
//                         value: /\S+@\S+\.\S+/,
//                         message: "Invalid email",
//                     }
//                 })} label="Email" variant="outlined" error={Boolean(errors.email)} helperText={errors.email?.message} />
//                 <TextField {...register("orderNumber")} label="Order number (if applicable)" variant="outlined" error={Boolean(errors.orderNumber)} helperText={errors.orderNumber?.message} />
//                 <TextField {...register("message", { required: true })} label="Message" multiline variant="outlined" error={Boolean(errors.message)} helperText={errors.message?.message} />

//                 {error && <Alert severity="error" variant='filled'>{error}</Alert>}
//                 {success && <Alert severity="success" variant='filled'>Sent! We will get back to you as soon as possible - hang tight</Alert>}

//                 <div data-netlify-recaptcha="true"></div>

//                 <LoadingButton type="submit" endIcon={<Send />} variant="contained" color="primary" loading={submitting} disabled={!isValid || submitting}>
//                     Send
//                 </LoadingButton>
//             </Stack>
//         </form>
//     )
// }

export default function Contact() {
    // const theme = useTheme()
    // const isLargeMobile = useMediaQuery(theme.breakpoints.down("lg"))
    const headerSlantContainerNoContentStyles = headerSlantContainerNoContent();

    // const NotPrintable = styled('div')(notPrintable);

    const analytics = useAnalytics();
    useEffect(() => {
        analytics.trackPageView(AnalyticsPageType.page);
    }, [])

    return (
        // <GoogleReCaptchaProvider reCaptchaKey={recapchaSiteKey}>
        // </GoogleReCaptchaProvider>
        (<>
            <HorizontalSlantContainer id={"contact"} autoHeight>
                <Container sx={headerSlantContainerNoContentStyles}></Container>
            </HorizontalSlantContainer>
            <Container sx={{ pt: 6 }}>
                <Grid
                    container
                    spacing={4}
                    justifyContent="space-between"
                >
                    <Grid
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6
                        }}>
                        <Stack spacing={2}>
                            <Box>
                                <Typography variant="h1" gutterBottom>
                                    Reach out!
                                </Typography>
                                <Typography variant="h5" gutterBottom>
                                    We'd love to hear from you.
                                </Typography>
                            </Box>

                            <Alert severity='info' variant='filled' icon={<ArrowDownward />}>Use the chat bubble at the bottom of the page to get in touch</Alert>

                            {/* <ContactForm /> */}
                        </Stack>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6
                        }}>
                        <Stack spacing={2}>
                            <Box>
                                <Typography variant="h3" gutterBottom>
                                    Frequently Asked Questions
                                </Typography>
                            </Box>

                            <FaqList />
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
        </>)
    );
}
export const Head = (props: PageProps) => {
    return (
        <SeoHead
            title="Contact"
            pathname={props.location.pathname}
            description="Contact Blootropic"
        />
    )
}
